/**
 * Admin API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MessageConfig { 
    id?: string;
    epmLocationId?: number;
    active?: boolean;
    timeBefore?: number;
    dayOf?: MessageConfig.DayOfEnum;
    weekOf?: MessageConfig.WeekOfEnum;
    hourToRun?: string;
    content?: string;
    type?: MessageConfig.TypeEnum;
    messagingPhoneNumberId?: number;
}
export namespace MessageConfig {
    export const DayOfEnum = {
        Monday: 'MONDAY',
        Tuesday: 'TUESDAY',
        Wednesday: 'WEDNESDAY',
        Thursday: 'THURSDAY',
        Friday: 'FRIDAY',
        Saturday: 'SATURDAY',
        Sunday: 'SUNDAY'
    } as const;
    export type DayOfEnum = typeof DayOfEnum[keyof typeof DayOfEnum];
    export const WeekOfEnum = {
        First: 'FIRST',
        Second: 'SECOND',
        Third: 'THIRD',
        Fourth: 'FOURTH'
    } as const;
    export type WeekOfEnum = typeof WeekOfEnum[keyof typeof WeekOfEnum];
    export const TypeEnum = {
        Reminders: 'REMINDERS',
        Recalls: 'RECALLS',
        Registrations: 'REGISTRATIONS',
        DayOfReminders: 'DAY_OF_REMINDERS',
        OrderNotifications: 'ORDER_NOTIFICATIONS',
        TextReminders: 'TEXT_REMINDERS',
        PhoneReminders: 'PHONE_REMINDERS',
        RecallReports: 'RECALL_REPORTS',
        Surveys: 'SURVEYS',
        RecallsByLastExamDate: 'RECALLS_BY_LAST_EXAM_DATE',
        MessageBlast: 'MESSAGE_BLAST'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


